import { useState } from 'react';
import { GoChevronDown, GoChevronLeft } from 'react-icons/go';

function ExpandablePanel({ header, orderButtons, toolbarIcons, children, expanded, onToggle }) {
  const [internalExpanded, setInternalExpanded] = useState(false);
  const isControlled = typeof expanded === 'boolean';
  const isExpanded = isControlled ? expanded : internalExpanded;

  const handleClick = () => {
    if (isControlled) {
      if (onToggle) onToggle(!expanded);
      return;
    }

    setInternalExpanded((prevExpanded) => {
      const nextExpanded = !prevExpanded;
      if (onToggle) onToggle(nextExpanded);
      return nextExpanded;
    });
  };

  return (
    <div className="flex flex-col rounded-lg p-2 m-2 text-lg border-solid border-2 border-gray-300 bg-white">
      <div className="flex p-1 justify-between items-center">
        <div className="flex flex-row items-center justify-between">
          <div flex className='flex flex-row mr-4'>
            {orderButtons}
            {/* <div className="w-px h-6 bg-gray-300"></div> */}
          </div>
          <div className='mr-2'>
            {toolbarIcons}
          </div>
          <div className='cursor-pointer' onClick={handleClick}>
            {header}
          </div>
        </div>
        <div onClick={handleClick} className="cursor-pointer">
          {isExpanded ? <GoChevronDown /> : <GoChevronLeft />}
        </div>
      </div>
      {isExpanded && <div className="p-1 ">{children}</div>}
    </div>
  );
}

export default ExpandablePanel;